'use client';

import Link from 'next/link';
import styles from './index.module.scss';
import MainButton from '@/app/_components/Shared/MainButton';

export default function GetStartedSection() {
  return (
    <section className={styles.container}>
      <div className="container-wrapper">
        <div className={styles.content}>
          <div className={styles.badge}>Get Started Today</div>
          <h2 className={styles.title}>
            Start small, grow fast, and watch your benefits expand automatically
          </h2>
          <p className={styles.description}>
            Whether you are a freelancer, growing business, or enterprise client, NINJAZ PRO adapts to your needs while giving maximum efficiency and value.
          </p>
          <div className={styles.buttons}>
            <Link href="/pro-services-request">
              <MainButton color="info">
                Sign Up
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </MainButton>
            </Link>
            <Link href="/contact">
              <MainButton color="white">
                Request a Demo
              </MainButton>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
